import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import MenuButton from '../../../../../Common/MenuButton/MenuButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFunnelDollar, faUsersCog, faScroll, faCalendarAlt, faHotel, faSchool, faFileSignature } from '@fortawesome/free-solid-svg-icons';
import classes from './menu.module.css';
import { ADD_TOAST_MESSAGE } from '../../../../../Redux/Enums/Contracts.Globals.Enums';

const Menu = ({ isLoading, handleActiveModal }) => {
    const fees = useSelector(state => state.fees);
    const teams = useSelector(state => state.teams);
    const isSupervisor = useSelector(state => state.user.isSupervisor);
    const dispatch = useDispatch();

    if (isLoading) {
        return (
            <section className={classes.page} style={{ background: 'white', width: '100%' }}>
                <CircularProgress size={300} thickness={4} />
            </section>
        );
    } else {
        return (
            <section className={classes.page}>
                <Grid container spacing={2} alignItems="center" justifyContent="space-around" style={{ width: '96%' }}>
                    <Grid item lg={4} md={6} sm={12} xs={12}>
                        <MenuButton
                            title="Step 1: Template Configuration"
                            icon={() => <FontAwesomeIcon icon={faFileSignature} size="8x" />}
                            width="80%"
                            onClick={() => {
                                if (isSupervisor) {
                                    handleActiveModal('templates');
                                } else {
                                    dispatch({
                                        type: ADD_TOAST_MESSAGE,
                                        payload: { severity: 'warning', message: 'No Access for Template Configuration Details. Please contact Administrator.' }
                                    });
                                }
                            }}
                        />
                    </Grid>
                    <Grid item lg={4} md={12} sm={12} xs={12}>
                        <MenuButton
                            title="Step 2: Appointment Management"
                            icon={() => <FontAwesomeIcon icon={faUsersCog} size="8x" />}
                            width="80%"
                            onClick={() => handleActiveModal('teams')}
                        >
                            <Typography variant="subtitle2" component="div" align="center">
                                Progress: {`${teams.count.total - teams.count.complete}/${teams.count.total}`}
                            </Typography>
                        </MenuButton>
                    </Grid>
                    <Grid item lg={4} md={12} sm={12} xs={12}>
                        <MenuButton
                            title="Step 3: Contract Fees Initialisation"
                            icon={() => <FontAwesomeIcon icon={faFunnelDollar} size="8x" />}
                            width="80%"
                            onClick={() => handleActiveModal('fees')}
                        >
                            <Typography variant="subtitle2" component="div" align="center">
                                Progress: {`${fees.count.total - fees.count.complete}/${fees.count.total}`}
                            </Typography>
                        </MenuButton>
                    </Grid>
                    <Grid item lg={3} md={12} sm={12} xs={12}>
                        <MenuButton
                            title="Step 4: Script Allocation"
                            icon={() => <FontAwesomeIcon icon={faScroll} size="8x" />}
                            width="95%"
                            onClick={() => handleActiveModal('script_allocation')}
                        />
                    </Grid>
                    <Grid item lg={3} md={12} sm={12} xs={12}>
                        <MenuButton
                            title="Step 5: Delivery & Return Dates"
                            icon={() => <FontAwesomeIcon icon={faCalendarAlt} size="8x" />}
                            width="95%"
                            onClick={() => handleActiveModal('script_dates')}
                        />
                    </Grid>
                    <Grid item lg={3} md={12} sm={12} xs={12}>
                        <MenuButton
                            title="Step 6: Marker Meetings"
                            icon={() => <FontAwesomeIcon icon={faHotel} size="8x" />}
                            width="95%"
                            onClick={() => handleActiveModal('marker_meetings')}
                        />
                    </Grid>
                </Grid>
            </section>
        );
    }
};

export default Menu;
